import React from "react";
import './Navbar.css'
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav className="navbar navbar-expand-lg ">
      <div className="container-fluid">
        <a className="navbar-brand fw-bold text-info" href="#home">
          <img src="logo.png" className="img-fluid logo" alt="logo" />
        </a>
        <button
          className="navbar-toggler custom-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav mx-auto gap-3">
            <li className="nav-item">
              <a className="nav-link" href="#home">
                {t('nav.home')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#about">
                {t('nav.about')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#why-us">
                {t('nav.why_us')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#partners">
                {t('nav.partners')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#products">
                {t('nav.products')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contact">
                {t('nav.contact')}
              </a>
            </li>
          </ul>
          <button 
            className="btn btn-outline-light ms-3 fw-semibold" 
            onClick={toggleLanguage}
          >
            {i18n.language === 'en' ? 'Ar' : 'En'}
          </button>
          <a href="#contact" className="contact-btn px-4 rounded-1 py-2 ms-3 d-flex align-items-center justify-content-center text-decoration-none">
            {t('nav.contact_us')}
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
